import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import products from './modules/products';
import email from './modules/email';
import todo from './modules/todo';
import firebase_todo from './modules/firebase_todo';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';

// Porfolio
import blog from './modules/portfolio/blog.js';
import collaboration from './modules/portfolio/collaboration.js';
import gallery from './modules/portfolio/gallery.js';
import publication from './modules/portfolio/publication.js';
import media from './modules/portfolio/media.js';
import recent from './modules/portfolio/recents.js';

// Project Doc
import country from './modules/project-doc/country.js';
import district from './modules/project-doc/district.js';
import area from './modules/project-doc/area.js';
import camp from './modules/project-doc/camp.js';
import block from './modules/project-doc/block.js';
import asset from './modules/project-doc/asset.js';
import volunteer from './modules/project-doc/volunteer.js';
import shelter from './modules/project-doc/shelter.js';

import house from './modules/project-doc/house.js';
import contact from './modules/project-doc/contact.js';
import dashboard from './modules/project-doc/dashboard';
import relief from './modules/project-doc/relief.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},

    mutations: {
        changeLang (state, payload) {
            localStorage.setItem('currentLanguage', payload.id);
            localStorage.setItem('currentLanguageIcon', payload.icon);
            window.location.reload();
        }
    },

    actions: {
        setLang ({ commit }, payload) {
            commit('changeLang', payload);
        }
    },

    modules: {
        alert,
        authentication,
        users,
        layout,
        chat,
        menu,
        products,
        email,
        todo,
        firebase_todo,
        jobs,
        courses,
        common,

        //Portfolio
        blog,
        collaboration,
        gallery,
        publication,
        media,
        recent,

        // Project Doc
        country,
        district,
        area,
        camp,
        block,
        asset,
        volunteer,
        
        shelter,
        house,
        contact,
        dashboard,
        relief
    }
});

